module.exports = __webpack_public_path__ + "static/media/mano_dia.72406479.svg";